import { render, staticRenderFns } from "./TagEditor.vue?vue&type=template&id=ca2c0f96&"
import script from "./TagEditor.vue?vue&type=script&lang=js&"
export * from "./TagEditor.vue?vue&type=script&lang=js&"
import style0 from "./TagEditor.vue?vue&type=style&index=0&id=ca2c0f96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports